import React from "react";

const Terms: React.FC = () => {
  return (
    <section className="schedule-three ngo_list_wrapper ngo_lists">
      <div className="container">
        <div className="schedule-three__top">
          <div
            className="section-title text-center wow fadeInLeft"
            data-wow-delay="100ms"
          >
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">
                Last Updated: 06/01/2025
              </span>
            </div>
            <h2 className="section-title__title">
              ImpactUp - Terms and Conditions
            </h2>
          </div>
        </div>
        <div className="schedule-three__bottom">
          <p className="event-two__text">
            Welcome to ImpactUp (“the Platform,” “we,” “us,” “our”). By using
            ImpactUp to create, host, or attend an event, you agree to the
            following Terms and Conditions. Please read them carefully before
            using our services.
          </p>
          <p className="event-two__text">
            <strong>1. Acceptance of Terms</strong>
            <br />
            By accessing or using ImpactUp, you confirm that you are at least 18
            years old (or have legal guardian consent) and agree to these Terms,
            our Privacy Policy, and any applicable community guidelines.
          </p>
          <p className="event-two__text">
            <strong>2. Purpose of the Platform</strong>
            <br />
            ImpactUp is designed to empower individuals and organizations to
            create, host, and participate in purpose-driven, community-focused
            events.
            <br />
            While we provide tools to facilitate event promotion and engagement,
            ImpactUp is not a party to any event and is not responsible for
            actions of hosts, attendees, or third parties.
          </p>
          <p className="event-two__text">
            <strong>3. Host Responsibilities</strong>
            <br />
            If you host an event via ImpactUp, you agree to:
            <ul className="ms-5">
              <li>
                Ensure the event complies with local laws, safety regulations,
                and venue rules.
              </li>
              <li>
                Clearly state any requirements, restrictions, or risks
                associated with your event.
              </li>
              <li>Obtain any necessary permits, insurance, or permissions.</li>
              <li>
                Take reasonable health, safety, and security measures for all
                participants.
              </li>
              <li>
                Be responsible for the accuracy of event information, including
                date, time, and location.
              </li>
              <li>Respond promptly to attendee questions or concerns.</li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>4. Attendee Responsibilities</strong>
            <br />
            If you attend an event via ImpactUp, you agree to:
            <ul className="ms-5">
              <li>
                Review and understand all event details, including safety
                notices, before attending.
              </li>
              <li>
                Follow all instructions from event hosts, venue staff, and local
                authorities.
              </li>
              <li>
                Take personal safety measures, including bringing necessary
                equipment, clothing, or supplies.
              </li>
              <li>
                Respect other attendees, hosts, and the community environment.
              </li>
              <li>
                Accept any inherent risks related to the nature of the event
                (e.g., outdoor activities, community clean-ups).
              </li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>5. Prohibited Activities</strong>
            <br />
            You agree not to:
            <ul className="ms-5">
              <li>
                Post or promote illegal, discriminatory, or harmful events.
              </li>
              <li>Harass, threaten, or endanger other users.</li>
              <li>Misrepresent yourself, your event, or your affiliation.</li>
              <li>
                Use ImpactUp for commercial purposes unrelated to community or
                purpose-driven events without prior approval.
              </li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>6. Liability Disclaimer</strong>
            <ul className="ms-5">
              <li>
                ImpactUp provides a platform for connecting hosts and attendees
                but does not oversee event execution.
              </li>
              <li>
                We are not responsible for injuries, damages, or losses arising
                from events.
              </li>
              <li>All participation is at your own risk.</li>
              <li>
                Hosts and attendees are responsible for obtaining their own
                insurance coverage, if necessary.
              </li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>7. Cancellation & Refunds</strong>
            <ul className="ms-5">
              <li>
                Refund policies (if applicable) are determined by the event
                host, not ImpactUp.
              </li>
              <li>
                ImpactUp is not responsible for event cancellations,
                postponements, or changes.
              </li>
            </ul>
          </p>
          <p className="event-two__text">
            <strong>8. Privacy & Data</strong>
            <br />
            Your use of ImpactUp is subject to our Privacy Policy, which
            explains how we collect, store, and use your data.
          </p>
          <p className="event-two__text">
            <strong>9. Modifications to Terms</strong>
            <br />
            ImpactUp may update these Terms at any time. Continued use of the
            Platform constitutes acceptance of the updated Terms.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Terms;
